import { useEffect } from 'react';
import { t } from '@lingui/macro';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { useTutorials } from 'components/PortalTours/useTutorials.hook';
import { StandAloneCalculator } from 'components/StandAloneCalculator/StandAloneCalculator';
import { useSearchParams } from 'react-router-dom';
import styles from './calculator.module.css';

export const CalculatorPage = () => {
  const [searchParams] = useSearchParams();
  const { triggerCalculatorTour } = useTutorials();

  useEffect(() => {
    if (searchParams.get('_showTour') === 'true') {
      triggerCalculatorTour();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  return (
    <BaseLayout
      className={styles.container}
      pageTitle={t`Calculator | Introducer Portal`}
    >
      <StandAloneCalculator />
    </BaseLayout>
  );
};
